module.exports = __webpack_public_path__ + "static/img/icon_embedded@2x.e75115ed.png";